import React from "react"
import BackArrow from "./back-arrow"
import CancelArrow from "./cancel-arrow"
import USD from "../usd"

const Stats = (props) => {
  const session = props.lastSessionId && props.sessions.find(s => s.id == props.lastSessionId)
  if (!session) return null
  const {cardAmount, cashAmount, reservationAmount, shopAmount, tipAmount, today, startedAt} = session
  const {cardStats, cashStats, reservationStats, shopStats, tipStats} = session.settings
  return (
    <div className="clock-in-panel__info-window clock-in-stats" style={props.statsStyle}>
      {!props.statsWithCancel && <BackArrow {...props}/>}
      {props.statsWithCancel && <CancelArrow {...props}/>}
      <div className="clock-in-window">
        {today && <h1>Today's Stats</h1>}
        {!today && <h1>{moment(startedAt).format('MMMM D')} Stats</h1>}
        <h3>Total Sales</h3>
        <div className="clock-in-stats__total"><USD space val={cardAmount + cashAmount}/></div>
        <table className="clock-in-stats-table">
          <tbody>
            {shopStats && <tr><td>POS Sales</td><td><USD space val={shopAmount}/></td></tr>}
            {reservationStats && <tr><td>Field Rental</td><td><USD space val={reservationAmount}/></td></tr>}
            {cardStats && <tr><td>Total CC</td><td><USD space val={cardAmount}/></td></tr>}
            {cashStats && <tr><td>Total Cash</td><td><USD space val={cashAmount}/></td></tr>}
            {tipStats && <tr><td>Tips</td><td><USD space val={tipAmount}/></td></tr>}
          </tbody>
        </table>
        <button onClick={props.onClickCancel}>Done</button>
      </div>
    </div>
  )
}

export default Stats
